// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orcamentos_PegaOrigensResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /orcamentos/pega_origens
 *
 * Returns list of origem options for orcamentos.
 */
import type { Orcamentos_PegaOrigensRow } from './Orcamentos_PegaOrigensRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Orcamentos_PegaOrigensResponseDados = Orcamentos_PegaOrigensRow[];

export type Orcamentos_PegaOrigensResponse = ApiResponse<Orcamentos_PegaOrigensResponseDados>;

registerResponseContract('Orcamentos_PegaOrigensResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      origem_id:          { type: 'number',  required: true },
      origem_nome:        { type: 'string',  required: true },
      origem_franquia_id: { type: 'number',  required: true },
      background_color:   { type: 'string',  required: false },
    },
  },
})
